/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
class BaiduSearchEngine {
    getSearchUrl(query, options) {
        const excludeDomainsQuery = options.excludeDomains && options.excludeDomains.length > 0 ? options.excludeDomains.map((domain)=>`-site:${domain}`).join(' ') : '';
        const searchParams = new URLSearchParams({
            wd: excludeDomainsQuery ? `${excludeDomainsQuery} ${query}` : query,
            rn: `${options.count || 10}`
        });
        return `https://www.baidu.com/s?${searchParams.toString()}`;
    }
    extractSearchResults(window) {
        const links = [];
        const document = window.document;
        const extractSnippet = (element)=>{
            const clone = element.cloneNode(true);
            const titleElements = clone.querySelectorAll('.t');
            titleElements.forEach((el)=>el.remove());
            const nonContentElements = clone.querySelectorAll('.c-tools, .c-gap-top');
            nonContentElements.forEach((el)=>el.remove());
            const scriptElements = clone.querySelectorAll("script, style");
            scriptElements.forEach((el)=>el.remove());
            const text = Array.from(clone.querySelectorAll('*')).filter((node)=>{
                var _node_textContent;
                return null === (_node_textContent = node.textContent) || void 0 === _node_textContent ? void 0 : _node_textContent.trim();
            }).map((node)=>{
                var _node_textContent;
                return null === (_node_textContent = node.textContent) || void 0 === _node_textContent ? void 0 : _node_textContent.trim();
            }).filter(Boolean).reduce((acc, curr)=>{
                if (!acc.some((text)=>text.includes(curr) || curr.includes(text))) acc.push(curr);
                return acc;
            }, []).join(' ').trim().replace(/\s+/g, ' ');
            return text;
        };
        try {
            const elements = document.querySelectorAll('.c-container');
            elements.forEach((element)=>{
                const titleEl = element.querySelector('a');
                const url = null == titleEl ? void 0 : titleEl.getAttribute('href');
                const snippet = extractSnippet(element);
                if (!url) return;
                const item = {
                    title: (null == titleEl ? void 0 : titleEl.textContent) || '',
                    url,
                    content: '',
                    snippet
                };
                if (!item.title || !item.url) return;
                links.push(item);
            });
        } catch (error) {
            console.error(error);
        }
        return links;
    }
    async waitForSearchResults(page) {
        await page.waitForSelector('#content_left');
    }
}
export { BaiduSearchEngine };

//# sourceMappingURL=baidu-engine.mjs.map